export const INACTIVITY_TIMEOUT = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
export const LAST_ACTIVITY_KEY = 'lastActivityTimestamp'; // Key for localStorage